<template>
  <div class="spec-row">
    <span>{{ TLang('规格','my') }}</span>
    <div class="list-wrap">
      <ul :style="{ overflowY:specList.length > 4 ? 'scroll' : 'auto' }">
        <li
          v-for="goods in specList"
          :key="goods.goodsId"
          :class="{
            'activeGoods': goods.goodsId === activeId,
            'gray': goods.gray && goods.bizStock === null || goods.bizStock === 0
          }"
          @click="chooseSpecGoods(goods)"
        >
          <el-tooltip
            effect="light"
            :content="TLang('该商品已售罄', 'goods')"
            placement="top"
            :disabled="goods.stockStatus !== 3"
            popper-class="goods-tip"
            :tabindex="goods.goodsId"
          >
            <!-- <el-button>上左</el-button> -->
            <p>{{ goods.specValue }}</p>
          </el-tooltip>
          <!-- {{ goods.specValue }} -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getQueryString } from '@utils';
export default {
  props: {
    specList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    onChange: {
      type: Function,
    },
  },
  data() {
    return {
      activeId: null,
    };
  },
  created() {
    console.log('specList', this.specList);
    this.specList.map(goods => {
      if (goods.goodsId == getQueryString('gid')) {
        this.activeId = goods.goodsId;
      }
    });
  },
  methods: {
    chooseSpecGoods(goods) {
      // if (!goods.gray) {
      //   this.activeId = goods.goodsId;
      //   // if(goods.goodsId !== this.activeId){
      //   this.onChange && this.onChange(goods);
      //   // }
      // }
      this.activeId = goods.goodsId;
      // if(goods.goodsId !== this.activeId){
      this.onChange && this.onChange(goods);
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.spec-row {
  display: flex;
  span {
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    line-height: 40px;
  }
  .list-wrap {
    margin-left: 24px;
    // padding-top: 20px;
    ul {
      display: flex;
      flex-wrap: wrap;
      max-width: 650px;
      max-height: 300px;
      overflow-y: scroll;
      li {
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
        line-height: 40px;
        text-align: center;
        border: 1px solid rgba(229, 229, 229, 1);
        padding: 0 12px;
        margin-right: 16px;
        margin-bottom: 16px;
        &:hover {
          cursor: pointer;
        }
      }
      li.activeGoods {
        border: 2px solid #3FA6FF;
        border: 2px solid var(--df-primary-color, #3FA6FF);
        color: #111;
        position: relative;
        &::after{
          position: absolute;
          bottom: 0;
          right: 0;
          content: "";
          width: 0;
          height: 0;
          border-bottom: 10px solid #3FA6FF;
          border-bottom: 10px solid var(--df-primary-color, #3FA6FF);
          border-left: 10px solid transparent;
        }
      }
      li.gray {
        background: rgba(51, 51, 51, 0.03);
        border: 1px solid rgba(204, 204, 204, 1);
        border-style: dashed;
        color: #666;
        // &:hover {
        //   cursor: not-allowed;
        // }
      }
      li.gray.activeGoods{
        border: 2px solid #3FA6FF;
        border: 2px solid var(--df-primary-color, #3FA6FF);
        background: rgba(51, 51, 51, 0.03);
        color: #666;
      }
    }
  }
}
</style>
